import permissions from '../permissions'

const INCIDENT_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.INCIDENTS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.CREATE,
    tag: permissions.INCIDENTS.CREATE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.INCIDENTS.MANAGE,
  },
]

export default INCIDENT_LIST
